import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken } from "../lib/api";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const readLS = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};

export function StoreProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [settings, setSettings] = useState({});
  const [cart, setCart] = useState(() => readLS("iah_cart", []));
  const [wishlist, setWishlist] = useState(() => readLS("iah_wishlist", []));
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => { localStorage.setItem("iah_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("iah_wishlist", JSON.stringify(wishlist)); }, [wishlist]);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    const t = localStorage.getItem("iah_token");
    if (t) {
      api.get("/auth/me").then((r) => setUser(r.data.user))
        .catch(() => setToken(null))
        .finally(() => setAuthReady(true));
    } else setAuthReady(true);
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token); setUser(r.data.user); return r.data.user;
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setToken(r.data.token); setUser(r.data.user); return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null); setUser(null);
  };

  const addToCart = useCallback((product, qty = 1) => {
    setCart((prev) => {
      const ex = prev.find((i) => i.slug === product.slug);
      if (ex) return prev.map((i) => i.slug === product.slug ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        slug: product.slug, name: product.name, price: product.price, mrp: product.mrp,
        image: (product.images || [])[0] || (product.images || [])[1], size: product.size, quantity: qty,
      }];
    });
    setCartOpen(true);
  }, []);
  const updateQty = (slug, qty) => setCart((p) => qty <= 0 ? p.filter(i => i.slug !== slug) : p.map(i => i.slug === slug ? { ...i, quantity: qty } : i));
  const removeFromCart = (slug) => setCart((p) => p.filter(i => i.slug !== slug));
  const clearCart = () => setCart([]);

  const toggleWishlist = (slug) => {
    setWishlist((p) => p.includes(slug) ? p.filter(s => s !== slug) : [...p, slug]);
    if (localStorage.getItem("iah_token")) api.post(`/wishlist/${slug}`).catch(() => {});
  };

  const cartCount = cart.reduce((a, i) => a + i.quantity, 0);
  const cartSubtotal = cart.reduce((a, i) => a + i.price * i.quantity, 0);

  return (
    <StoreContext.Provider value={{
      user, setUser, authReady, settings,
      login, register, logout,
      cart, addToCart, updateQty, removeFromCart, clearCart, cartCount, cartSubtotal,
      cartOpen, setCartOpen,
      wishlist, toggleWishlist,
    }}>
      {children}
    </StoreContext.Provider>
  );
}
